/**
 * Hebrew error messages for the application
 */

export const errorMessages = {
  // Network errors
  networkError: 'שגיאת רשת. אנא בדוק את החיבור שלך לאינטרנט.',
  offline: 'אין חיבור לאינטרנט. אנא בדוק את החיבור שלך.',
  timeout: 'הבקשה לקחה יותר מדי זמן. אנא נסה שוב.',
  
  // Authentication errors
  authError: 'שגיאת אימות. אנא התחבר מחדש.',
  invalidCredentials: 'שם משתמש או סיסמה שגויים.',
  sessionExpired: 'ההפעלה פגה. אנא התחבר מחדש.',
  unauthorized: 'אין לך הרשאה לגשת למשאב זה.',
  
  // Form validation errors
  requiredField: 'שדה חובה',
  invalidEmail: 'כתובת אימייל לא תקינה',
  passwordTooShort: 'הסיסמה חייבת להכיל לפחות 8 תווים',
  passwordMismatch: 'הסיסמאות אינן תואמות',
  
  // Payment errors
  paymentFailed: 'התשלום נכשל. אנא נסה שוב.',
  paymentCancelled: 'התשלום בוטל.',
  invalidPaymentDetails: 'פרטי התשלום אינם תקינים.',
  
  // Course errors
  courseNotFound: 'השיעור לא נמצא.',
  lessonNotFound: 'השיעור לא נמצא.',
  contentLoadError: 'שגיאה בטעינת התוכן. אנא נסה שוב.',
  
  // Calendar errors
  calendarUpdateError: 'שגיאה בעדכון היומן. אנא נסה שוב.',
  progressSaveError: 'שגיאה בשמירת ההתקדמות. אנא נסה שוב.',
  
  // Generic errors
  genericError: 'אירעה שגיאה. אנא נסה שוב מאוחר יותר.',
  notFound: 'הדף שחיפשת לא נמצא.',
  serverError: 'שגיאת שרת. אנא נסה שוב מאוחר יותר.',
  
  // Success messages
  loginSuccess: 'התחברת בהצלחה!',
  passwordCreated: 'הסיסמה נוצרה בהצלחה!',
  progressSaved: 'ההתקדמות נשמרה בהצלחה!',
  paymentSuccess: 'התשלום בוצע בהצלחה!',
  
  // Loading messages
  loading: 'טוען...',
  processing: 'מעבד...',
  saving: 'שומר...',
  authenticating: 'מאמת...',
} as const;

/**
 * Get error message from error object
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  
  if (typeof error === 'string') {
    return error;
  }
  
  if (error && typeof error === 'object' && 'message' in error) {
    return String(error.message);
  }
  
  return errorMessages.genericError;
}

/**
 * Map HTTP status codes to Hebrew error messages
 */
export function getHttpErrorMessage(statusCode: number): string {
  switch (statusCode) {
    case 400:
      return 'בקשה לא תקינה. אנא בדוק את הנתונים שהזנת.';
    case 401:
      return errorMessages.authError;
    case 403:
      return errorMessages.unauthorized;
    case 404:
      return errorMessages.notFound;
    case 408:
      return errorMessages.timeout;
    case 500:
    case 502:
    case 503:
    case 504:
      return errorMessages.serverError;
    default:
      return errorMessages.genericError;
  }
}
